namespace GeniuzPOS.PosShift {
    export namespace PsPosShiftControlService {
        export const baseUrl = 'PosShift/PsPosShiftControl';

        export declare function Create(request: Serenity.SaveRequest<PsPosShiftControlRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPosShiftControlRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPosShiftControlRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPosShiftControlRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsPosShiftControl/Create",
            Update = "PosShift/PsPosShiftControl/Update",
            Delete = "PosShift/PsPosShiftControl/Delete",
            Retrieve = "PosShift/PsPosShiftControl/Retrieve",
            List = "PosShift/PsPosShiftControl/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPosShiftControlService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
